import styled from '../../theme/styled-with-theme';
import { mediaQueries, breakpoints } from '../../styles/media-queries';

import { Box } from '../Box';
import { Text } from '../Text';
import { Flexbox } from '../Flexbox';

export const NoOverflowBox = styled(Box)`
  overflow: hidden;
  position: relative;
  z-index: 0;
`;

export const ImageWrapper = styled('div')<{ isMobile?: boolean }>`
  display: ${({ isMobile = false }) =>
    isMobile ? 'block' : 'none'} !important;

  ${mediaQueries.tablet} {
    display: ${({ isMobile = false }) =>
      isMobile ? 'none' : 'block'} !important;
  }
`;

export const HeroText = styled('div')`
  text-align: center;
  margin: auto;

  ${mediaQueries.tablet} {
    text-align: left;
    position: absolute;
    z-index: 1;
    top: 40%;
    transform: translate(0, -40%);
    bottom: 0;
    left: 0;
    right: 0;
  }
`;

export const DesktopHeading = styled(Text)`
  display: none;

  ${mediaQueries.tablet} {
    display: block;
  }
`;

export const MobileHeading = styled(Text)`
  ${mediaQueries.tablet} {
    display: none;
  }
`;

export const DesktopCopyWrapper = styled('div')`
  display: none;

  ${mediaQueries.tablet} {
    display: block;
  }
`;

export const MobileCopyWrapper = styled('div')`
  ${mediaQueries.tablet} {
    display: none;
  }
`;

export const QrCodeContainerDiv = styled('div')`
  height: 500px;

  @media (max-width: ${breakpoints.desktop}px) {
    height: 300px;
  }

  @media (max-width: ${breakpoints.tablet}px) {
    height: 0px;
  }
`;

export const QrCodeContainer = styled(Flexbox)`
  justify-content: center;
  align-items: center;
  position: absolute;
  min-height: 100%;
  min-width: 50%;

  @media (max-width: ${breakpoints.tablet}px) {
    display: none;
  }

  /* Additional styling for screens wider than 720px */
  ${mediaQueries.tablet} {
    /* Styles for larger devices */
    display: flex; /* Ensures Flexbox properties are applied */
    position: relative; /* Resets position to default */
    min-height: 0; /* Resets min-height to default */
    min-width: 100%;
  }

  ${mediaQueries.desktop} {
    position: absolute;
    min-height: 100%;
    min-width: 50%;
  }

  #appsflyer-qr-code-container canvas {
    padding: 50px;
    border: 2px solid #80d6b0;
    box-shadow: -10px 10px 3px 0 #80d6b0;
    border-radius: 50px;
  }

  @media (max-width: ${breakpoints.desktop}px) {
    #appsflyer-qr-code-container canvas {
      height: 200px;
      width: 200px;
    }
  }
`;
